export const BOOLEAN = 'Boolean';
//# sourceMappingURL=BOOLEAN.js.map